export const classes = {
  app: 'relative h-dvh w-screen overflow-hidden',
  content: 'relative z-10 size-full',
  settings: 'fixed right-5 top-5 z-20',
  notFound:
    'place-center size-full bg-site-background text-2xl text-taupe-2 dark:bg-[#1a1620] dark:text-mauve-2',
};
